import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, Info } from 'lucide-react';

const MONTHLY_POINTS = ['Billed every month', 'Flat price per region + tier', 'Flexible - cancel anytime', 'No penalty for adding investments'];
const ANNUAL_POINTS = ['Formula: Monthly x 10', 'Save 2 months (17% discount)', 'Price locked for 12 months', 'Best value for committed investors'];

const PricingInfoCards = ({ pricingConfigs }) => {
  const active = (pricingConfigs || []).filter(c => c.is_active && c.pricing_version === 'v3');
  return (
    <>
      <Card className="border-2 border-blue-500/30 bg-gray-700">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-white"><Info className="w-5 h-5 text-blue-400" />How Pricing Works (v3 — flat per tier)</CardTitle>
          <CardDescription className="text-gray-400">One price per region per tier. Annual = monthly &times; 10 (2 months free).</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-4 text-sm">
            <div className="bg-gray-800 p-4 rounded border border-gray-600">
              <h5 className="font-semibold text-emerald-400 mb-3 text-base">Monthly Pay-As-You-Go</h5>
              <ul className="text-gray-300 space-y-2 text-sm">{MONTHLY_POINTS.map(t => <li key={t}>- {t}</li>)}</ul>
            </div>
            <div className="bg-gray-800 p-4 rounded border border-gray-600">
              <h5 className="font-semibold text-purple-400 mb-3 text-base">Annual (Best Value)</h5>
              <ul className="text-gray-300 space-y-2 text-sm">{ANNUAL_POINTS.map(t => <li key={t}>- {t}</li>)}</ul>
            </div>
          </div>
        </CardContent>
      </Card>

      {active.length > 0 && (
        <Card className="border-2 border-purple-500/30 bg-gray-700">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-white"><DollarSign className="w-5 h-5 text-purple-400" />Active Rows Summary</CardTitle>
            <CardDescription className="text-gray-400">Flat monthly &amp; annual across regions and tiers</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left">
                <thead>
                  <tr className="border-b border-gray-600 text-gray-400">
                    <th className="py-2 pr-3">Region</th>
                    <th className="py-2 pr-3">Tier</th>
                    <th className="py-2 pr-3">Monthly</th>
                    <th className="py-2 pr-3">Annual</th>
                    <th className="py-2 pr-3">Countries</th>
                  </tr>
                </thead>
                <tbody>
                  {active.map(c => (
                    <tr key={c.config_id} className="border-b border-gray-700/50" data-testid={`pricing-row-summary-${c.config_id}`}>
                      <td className="py-2 pr-3 text-white">{c.region_name}</td>
                      <td className="py-2 pr-3">
                        <span className={c.tier === 'premium_continuity' ? 'text-blue-300' : 'text-emerald-300'}>
                          {c.tier === 'premium_continuity' ? 'Continuity' : 'Portfolio'}
                        </span>
                      </td>
                      <td className="py-2 pr-3 text-emerald-400 font-semibold">{c.symbol}{Number(c.monthly_amount).toLocaleString()}</td>
                      <td className="py-2 pr-3 text-purple-400 font-semibold">{c.symbol}{(Number(c.monthly_amount) * 10).toLocaleString()}</td>
                      <td className="py-2 pr-3 text-gray-400">{(c.countries || []).length}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default PricingInfoCards;
